import { render } from "./Plus.vue?vue&type=template&id=61d5b70d"
const script = {}
script.render = render

export default script